import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export function InquiriesManager() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/inquiries").then((res) => setItems(res.data));
  useEffect(() => { load(); }, []);

  const handleDelete = async (id) => {
    await api.delete(`/admin/inquiries/${id}`);
    toast.success("Deleted.");
    load();
  };

  return (
    <div data-testid="inquiries-manager" className="bg-background border border-border divide-y divide-border">
      {items.map((item) => (
        <div key={item.id} data-testid={`inquiry-row-${item.id}`} className="p-5 flex justify-between gap-4">
          <div>
            <p className="font-medium">{item.name} <span className="text-muted-foreground text-sm">· {item.email}</span></p>
            {item.phone && <p className="text-xs text-muted-foreground">{item.phone}</p>}
            {item.subject && <p className="text-sm mt-1 font-medium">{item.subject}</p>}
            <p className="text-sm text-muted-foreground mt-1">{item.message}</p>
          </div>
          <Button size="icon" variant="outline" className="rounded-none shrink-0" data-testid={`inquiry-delete-${item.id}`} onClick={() => handleDelete(item.id)}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
      {items.length === 0 && <p className="p-6 text-muted-foreground text-sm">No inquiries yet.</p>}
    </div>
  );
}
